import { FC } from 'react';
import { Link } from 'react-router-dom';
import { State } from 'redux/initialState';
import { useSelector } from 'react-redux';

import { formatNumber } from 'utils/formats';

import { Partner } from 'types';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';
import { useGetSplitDataForPartner } from '../../hooks/useGetSplitDataForPartner';

type SplitOperationDataRowProps = {
  index: number;
  partner: Partner;
};

const SplitOperationTableRow: FC<SplitOperationDataRowProps> = ({
  index,
  partner,
}) => {
  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );
  const { data } = useOperationDetailsPage();

  const { _id: partnerId, name: partnerName } = partner;

  const { data: splitData } = useGetSplitDataForPartner({
    splitOperation: data.operation,
    partner,
    isOldSplit: data.isOldOperation,
  });

  return (
    <>
      <td
        className="text-left vertical-align-middle pl-2 pl-md-2"
        key={`partner-name-${index}`}
      >
        <Link
          className="text-primary"
          to={`/detalle-socio/${actualSociety?._id}/${partnerId}`}
        >
          {partnerName}
        </Link>
      </td>

      <td
        className="text-right vertical-align-middle tb-col-md"
        key={`partner-sharesCount-${index}`}
      >
        {formatNumber(splitData.sharesCount)}
      </td>

      <td
        className="text-right vertical-align-middle"
        key={`partner-new-sharesCount-${index}`}
      >
        {formatNumber(splitData.newSharesCount)}
      </td>
    </>
  );
};
export default SplitOperationTableRow;
